export interface CampaignInsights {
  spend: number | null;
  impressions: number | null;
  clicks: number | null;
  reach: number | null;
  ctr: number | null;
  cpc: number | null;
  cpm: number | null;
  addToCart: number | null;
  initiateCheckout: number | null;
  purchase: number | null;
  cpa: number | null;
}

export interface Campaign {
  id: string;
  name: string | null;
  status: string | null;
  objective: string | null;
  buyingType: string | null;
  dailyBudgetCents: number | null;
  lifetimeBudgetCents: number | null;
  startTime: string | null;
  stopTime: string | null;
  createdTime: string | null;
  updatedTime: string | null;
  insights: CampaignInsights | null;
}

export interface AdSet {
  id: string;
  name: string | null;
  status: string | null;
  campaignId: string | null;
  optimizationGoal: string | null;
  billingEvent: string | null;
  dailyBudgetCents: number | null;
  lifetimeBudgetCents: number | null;
  startTime: string | null;
  endTime: string | null;
  createdTime: string | null;
  updatedTime: string | null;
}

export interface Ad {
  id: string;
  name: string | null;
  status: string | null;
  adsetId: string | null;
  creativeId: string | null;
  createdTime: string | null;
  updatedTime: string | null;
}

export type DatePreset = "today" | "yesterday" | "last_7d" | "last_30d" | "maximum";

export const DATE_PRESET_LABELS: Record<DatePreset, string> = {
  today: "今日",
  yesterday: "昨日",
  last_7d: "近 7 天",
  last_30d: "近 30 天",
  maximum: "全部",
};

export function statusBadge(status: string | null | undefined): string {
  if (!status) return "bg-gray-100 text-gray-700";
  if (status === "ACTIVE") return "bg-emerald-100 text-emerald-800";
  if (status === "PAUSED") return "bg-amber-100 text-amber-800";
  if (status === "DELETED" || status === "ARCHIVED") return "bg-gray-200 text-gray-700";
  return "bg-sky-100 text-sky-800";
}

export function formatMoney(value: number | null | undefined, currency = "USD"): string {
  if (value == null) return "—";
  return new Intl.NumberFormat("zh-CN", { style: "currency", currency, maximumFractionDigits: 2 }).format(value);
}

export function formatCentsMoney(cents: number | null | undefined, currency = "USD"): string {
  if (cents == null) return "—";
  return formatMoney(cents / 100, currency);
}

export function formatNumber(n: number | null | undefined): string {
  if (n == null) return "—";
  return new Intl.NumberFormat("zh-CN").format(n);
}
